import {Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation} from '@angular/core';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {AttackService} from '../../attack/attack.service';
import {Attack, AttackProfile} from '../../attack/attack';
import {Subscription} from 'rxjs/Subscription';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfigService} from '../config/config.service';
import {SupportDialogComponent} from '../../modals/support/support-dialog.component';
import {ModalErrorArgs} from '../../modals/modal-error-args';

@Component({
    selector: 'history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.scss',
        '../../../../node_modules/bootstrap/dist/css/bootstrap.css'],
    encapsulation: ViewEncapsulation.None
})
export class HistoryComponent implements OnInit {
    @ViewChild(DatatableComponent) historyTable: DatatableComponent;
    @ViewChild('editTmpl') editTmpl: TemplateRef<any>;
    @ViewChild('ipTmpl') ipTmpl: TemplateRef<any>;
    @ViewChild('timeTmpl') timeTmpl: TemplateRef<any>;
    @ViewChild('numTmpl') numTmpl: TemplateRef<any>;
    @ViewChild('MBTmpl') MBTmpl: TemplateRef<any>;
    @ViewChild('statusTmpl') statusTmpl: TemplateRef<any>;
    @ViewChild('supportTmpl') supportTmpl: TemplateRef<any>;

    @ViewChild('supportModal') private supportModal: SupportDialogComponent;



    selected: Attack[];
    gridMessage: string = 'Loading...';

   // temp: any = [];
    flag: boolean = false;

    rows: Attack[];
    columns: any[] = [];
    availableAttackProfiles: AttackProfile[] = [];

    private currentAttackSubscription: Subscription;
    currentAttack: Attack;
    canStartAttack: boolean = false;
    needsAttackSelection: boolean = true;
    runButtonEnabled: boolean = false;

    constructor(private attackService: AttackService, private router: Router, private cfgService: ConfigService) {
      //  this.temp = this.rows;
        this.rows = [];
    }

    /*updateFilter(event:any) {
        const val = event.target.value.toLowerCase();

        // filter our data
        const temp = this.temp.filter(function(d: any) {
            return d.name.toLowerCase().indexOf(val) !== -1 || !val;
        });

        // update the rows
        this.rows = temp;
        // Whenever the filter changes, always go back to the first page
        this.historyTable.offset = 0;
    }*/

    ngOnInit() {
        var me = this;

        this.selected = [];


        this.cfgService.availableAttackProfilesSubject
            .subscribe(
                (profiles) =>{
                    this.availableAttackProfiles = profiles;
                }
            );


        this.columns = [
            { prop: 'Name', name: 'DDoS Profile', resizeable:false, flexGrow:3 },
            { prop: 'AttackParams.TargetIpAddress', name: 'Target IP:Port', minwidth:150, cellTemplate: this.ipTmpl, resizeable:false, flexGrow:3 },
            { prop: 'Status', name: 'Status', minwidth:130, resizeable:false, cellTemplate: this.statusTmpl, flexGrow:2 },
            { prop: 'StartDateToDisplay', name: 'Start Time', minwidth:185, resizeable:false, flexGrow:3},
            { prop: 'runtime', name: 'Run Time', minwidth:150, resizeable:false, cellTemplate: this.timeTmpl, flexGrow:2 },
            { prop: 'Metrics.TxData', name: 'Outbound Data (MB)', minwidth:190, resizeable:false, cellTemplate: this.MBTmpl, flexGrow:3.7 },
            { prop: 'Metrics.TxFrameRate', name: 'Frames Per Second', minwidth:180, resizeable:false , cellTemplate: this.numTmpl, flexGrow:3.5 },
            { prop: 'Metrics.TxFrames', name: 'Frames Sent', minwidth:175, resizeable:false, cellTemplate: this.numTmpl, flexGrow:3 },
            { prop: 'ID', name: ' ', width:30, resizeable:false, cellTemplate: this.supportTmpl, cellClass:'icon-row', flexGrow:0.7 }
        ];

        /*this.currentAttackSubscription = this.attackService.currentAttack.subscribe(attack => {
            this.currentAttack = attack;
            this.canStartAttack = !attack || ['Stopped', 'Failed', 'Unknown'].indexOf(attack.Status) >= 0;

            if(this.canStartAttack && this.selected.length > 0){
                this.enableRunButton(true);
            }else{
                this.enableRunButton(false);
            }

        });*/
        this.currentAttackSubscription = this.cfgService.currentAttackSubject.subscribe(attack => {
            this.currentAttack = attack;
            this.canStartAttack = !attack || ['Stopped', 'Failed', 'Unknown'].indexOf(attack.Status) >= 0;

            if(this.canStartAttack && this.selected.length > 0){
                this.enableRunButton(true);
            }else{
                this.enableRunButton(false);
            }

        });

        this.cfgService.historySubject
            .subscribe(
                (attacks) =>{
                    //Even if it's empty, it will send an empty array with length 15 if it's coming from backend
                    if(attacks.length > 0){
                        me.flag = true;
                    }
                        attacks = attacks.filter(attack => {
                            return me.findWithAttr(me.availableAttackProfiles, 'Name', attack.AttackParams.AttackProfile) !== -1

                        });

                        attacks.map(attack => {
                        const profile = this.availableAttackProfiles[this.findWithAttr(this.availableAttackProfiles, 'Name', attack.AttackParams.AttackProfile)];
                        if(profile){
                            attack['Name'] = profile.Label;
                        }

                        let timeDiff = attack && attack.StartDate && (((attack.StopDate ? Date.parse(attack.StopDate) : new Date().getTime()) - Date.parse(attack.StartDate)) / 1000);
                        if(timeDiff){
                          attack['runtime'] = timeDiff;
                        }

                        let formatDateTime = this.cfgService.formatDateTime(attack.StartDate);
                        if(formatDateTime){
                         // attack['StartDate'] = formatDateTime;
                          attack['StartDateToDisplay'] = formatDateTime;
                        }
                    });
                    me.rows = [...attacks];
                    // The first time it comes through it will always be an empty array
                    if(!me.rows || me.rows.length === 0 && me.flag === true){
                        this.gridMessage = 'No data to display';
                    }else{
                        me.flag = true;
                    }
                }
            )

    }


    findWithAttr(array: any, attr: string, value: string) {
        for (var i = 0; i < array.length; i += 1) {
            if (array[i][attr] === value) {
                return i;
            }
        }
        return -1;
    }

    enableRunButton(value: boolean) : void{
      var me = this;
      if(this.selected.length > 0){
        this.needsAttackSelection = false;
      }else{
        this.needsAttackSelection = true;
      }
        this.runButtonEnabled = value;
    }

    onSelectHistory(s:any) {
        this.canStartAttack = !this.currentAttack || ['Stopped', 'Failed', 'Unknown'].indexOf(this.currentAttack.Status) >= 0;
        if(this.canStartAttack && this.selected.length > 0){
            this.enableRunButton(true);
        }else{
            this.enableRunButton(false);
        }
    }

    runAgain() {
        //console.log(this.selected[0].AttackParams);
        if (this.canStartAttack) {
            this.cfgService.currentAttackSubject.next(this.selected[0]);
            this.router.navigate(['']);

        }


    }



    showSupportModal(value: any){
        this.supportModal.showDialog(value);
    }

}



// WEBPACK FOOTER //
// ./src/app/main/history/history.component.ts